export default __webpack_public_path__ + "static/media/panel10.cb1bdc4b.jpg";